import Vue from "vue";
import Router from "vue-router";

import auth from "./middleware/auth";

Vue.use(Router);

const router = new Router({
	mode: "history",
	base: process.env.BASE_URL,
	routes: [
		{ path: "/dashboard", redirect: "/" },
		{
			path: "/",
			name: "home",
			component: () =>
				import(/* webpackChunkName: "home" */ "@/pages/Index.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/account/changepassword",
			name: "changepassword",
			component: () => import("@/pages/account/ChangePassword.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/changepassword", // hyperlink
						text: "Change Password", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/configuration/role",
			name: "role configuration",
			component: () => import("@/pages/configuration/role/Index.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/role", // hyperlink
						text: "Role", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/configuration/role/add",
			name: "role add configuration",
			component: () => import("@/pages/configuration/role/Add.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/configuration/role", // hyperlink
						text: "Role", // crumb text
						disabled: false,
					},
					{
						to: "",
						text: "Add", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/configuration/role/edit/:id",
			name: "role edit configuration",
			component: () => import("@/pages/configuration/role/Add.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/configuration/role", // hyperlink
						text: "Role", // crumb text
						disabled: false,
					},
					{
						to: "",
						text: "Edit", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/configuration/user",
			name: "user configuration",
			component: () => import("@/pages/configuration/user/Index.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/user", // hyperlink
						text: "User", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/configuration/user/add",
			name: "user add configuration",
			component: () => import("@/pages/configuration/user/Add.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/configuration/user", // hyperlink
						text: "User", // crumb text
						disabled: false,
					},
					{
						to: "",
						text: "Add", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/configuration/user/edit/:id",
			name: "user edit configuration",
			component: () => import("@/pages/configuration/user/Add.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/configuration/user", // hyperlink
						text: "User", // crumb text
						disabled: false,
					},
					{
						to: "",
						text: "Edit", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/category",
			name: "category",
			component: () => import("@/pages/category/Index.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/category", // hyperlink
						text: "Category", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/category/add",
			name: "category add",
			component: () => import("@/pages/category/Add.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/category", // hyperlink
						text: "Category", // crumb text
						disabled: false,
					},
					{
						to: "",
						text: "Add", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/category/edit/:id",
			name: "category edit",
			component: () => import("@/pages/category/Add.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/category", // hyperlink
						text: "Category", // crumb text
						disabled: false,
					},
					{
						to: "",
						text: "Edit", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/category/faq/:id",
			name: "category faq",
			component: () => import("@/pages/category/FAQ.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/category", // hyperlink
						text: "Category", // crumb text
						disabled: false,
					},
					{
						to: "",
						text: "FAQ", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/content",
			name: "content",
			component: () => import("@/pages/content/Index.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/content", // hyperlink
						text: "Content", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/content/add",
			name: "content add",
			component: () => import("@/pages/content/Add.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/content", // hyperlink
						text: "Content", // crumb text
						disabled: false,
					},
					{
						to: "",
						text: "Add", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/content/edit/:id",
			name: "content edit",
			component: () => import("@/pages/content/Add.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/content", // hyperlink
						text: "Content", // crumb text
						disabled: false,
					},
					{
						to: "",
						text: "Edit", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/notification",
			name: "notification ",
			component: () => import("@/pages/notification/Index.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/notification", // hyperlink
						text: "Notification", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/notification/add",
			name: "notification add ",
			component: () => import("@/pages/notification/Add.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/notification", // hyperlink
						text: "Notification", // crumb text
						disabled: false,
					},
					{
						to: "",
						text: "Add", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/notification/edit/:id",
			name: "notification edit ",
			component: () => import("@/pages/notification/Add.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/notification", // hyperlink
						text: "Notification", // crumb text
						disabled: false,
					},
					{
						to: "",
						text: "Edit", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/legalDocuments",
			name: "Legal Document",
			component: () => import("@/pages/legalDocuments/Index.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/legalDocument", // hyperlink
						text: "Legal Document", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/legalDocuments/add",
			name: "Legal Document Add",
			component: () => import("@/pages/legalDocuments/Add.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/legalDocuments", // hyperlink
						text: "Legal Document", // crumb text
						disabled: false,
					},
					{
						to: "",
						text: "Add", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/legalDocuments/edit/:id",
			name: "Legal Document edit",
			component: () => import("@/pages/legalDocuments/Add.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/legalDocuments", // hyperlink
						text: "Legal Document", // crumb text
						disabled: false,
					},
					{
						to: "",
						text: "Edit", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/contentImage",
			name: "Content Image",
			component: () => import("@/pages/content/ImageList.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/content", // hyperlink
						text: "Content", // crumb text
						disabled: false,
					},
					{
						to: "/contentImage",
						text: "Image", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/contentImage/add",
			name: "Content Image Add",
			component: () => import("@/pages/content/AddImage.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/content", // hyperlink
						text: "Content", // crumb text
						disabled: false,
					},
					{
						to: "/contentImage",
						text: "Image", // crumb text
						disabled: false,
					},
					{
						to: "",
						text: "Add", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/contentImage/edit/:id",
			name: "Content Image Edit",
			component: () => import("@/pages/content/AddImage.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/content", // hyperlink
						text: "Content", // crumb text
						disabled: false,
					},
					{
						to: "/contentImage",
						text: "Image", // crumb text
						disabled: false,
					},
					{
						to: "",
						text: "Edit", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/contentAttachment",
			name: "Content Attachment",
			component: () => import("@/pages/content/AttachmentList.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/content", // hyperlink
						text: "Content", // crumb text
						disabled: false,
					},
					{
						to: "/contentAttachment",
						text: "Attachment", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/contentAttachment/add",
			name: "Content Attachment Add",
			component: () => import("@/pages/content/AddAttachment.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/content", // hyperlink
						text: "Content", // crumb text
						disabled: false,
					},
					{
						to: "/contentAttachment",
						text: "Attachment", // crumb text
						disabled: false,
					},
					{
						to: "",
						text: "Add", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/contentAttachment/edit/:id",
			name: "Content Attachment Edit",
			component: () => import("@/pages/content/AddAttachment.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/content", // hyperlink
						text: "Content", // crumb text
						disabled: false,
					},
					{
						to: "/contentAttachment",
						text: "Attachment", // crumb text
						disabled: false,
					},
					{
						to: "",
						text: "Edit", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/fixedDeparture",
			name: "Fixed Departure",
			component: () => import("@/pages/content/FixedDepartureList.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/content", // hyperlink
						text: "Content", // crumb text
						disabled: false,
					},
					{
						to: "/fixedDeparture",
						text: "Fixed Departure", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/fixedDeparture/add",
			name: "Fixed Departure Add",
			component: () => import("@/pages/content/AddFixedDeparture.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/content", // hyperlink
						text: "Content", // crumb text
						disabled: false,
					},
					{
						to: "/fixedDeparture",
						text: "Fixed Departure", // crumb text
						disabled: false,
					},
					{
						to: "",
						text: "Add", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/fixedDeparture/edit/:id",
			name: "Fixed Departure Edit",
			component: () => import("@/pages/content/AddFixedDeparture.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/content", // hyperlink
						text: "Content", // crumb text
						disabled: false,
					},
					{
						to: "/fixedDeparture",
						text: "Fixed Departure", // crumb text
						disabled: false,
					},
					{
						to: "",
						text: "Edit", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/booking",
			name: "Booking",
			component: () => import("@/pages/booking/Index.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "", // hyperlink
						text: "Booking", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/booking/:id",
			name: "Booking Details",
			component: () => import("@/pages/booking/Detail.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/booking", // hyperlink
						text: "Booking", // crumb text
						disabled: false,
					},
					{
						to: "",
						text: "Details", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/feedback",
			name: "Feedback",
			component: () => import("@/pages/feedback/Index.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "", // hyperlink
						text: "Feedback", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/contactus",
			name: "Contactus",
			component: () => import("@/pages/contactus/Index.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "", // hyperlink
						text: "Contactus", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/inquiry",
			name: "Inquiry",
			component: () => import("@/pages/inquiry/Index.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "", // hyperlink
						text: "Inquiry", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/inquiry/:id",
			name: "Inquiry Details",
			component: () => import("@/pages/inquiry/Detail.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "", // hyperlink
						text: "Inquiry", // crumb text
						disabled: false,
					},
					{
						to: "",
						text: "Details", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/testimonials",
			name: "Testimonials",
			component: () => import("@/pages/testimonials/Index.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "", // hyperlink
						text: "Testimonials", // crumb text
						disabled: false,
					},
				],
			},
		},
		{
			path: "/testimonials/add",
			name: "Testimonials Add",
			component: () => import("@/pages/testimonials/Add.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/testimonials", // hyperlink
						text: "Testimonials", // crumb text
						disabled: false,
					},
					{
						to: "",
						text: "Add", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/testimonials/edit/:id",
			name: "Testimonials Edit",
			component: () => import("@/pages/testimonials/Add.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/testimonials", // hyperlink
						text: "Testimonials", // crumb text
						disabled: false,
					},
					{
						to: "",
						text: "Edit", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/blog",
			name: "Blog",
			component: () => import("@/pages/blog/Index.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "", // hyperlink
						text: "Blog", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/blog/add",
			name: "Blog Add",
			component: () => import("@/pages/blog/Add.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/blog", // hyperlink
						text: "Blog", // crumb text
						disabled: false,
					},
					{
						to: "",
						text: "Add", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/blog/edit/:id",
			name: "Blog Edit",
			component: () => import("@/pages/blog/Add.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/blog", // hyperlink
						text: "Blog", // crumb text
						disabled: false,
					},
					{
						to: "",
						text: "Edit", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/fieldStaff",
			name: "Field Staff",
			component: () => import("@/pages/fieldStaff/Index.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "", // hyperlink
						text: "Field Staff", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/fieldStaff/add",
			name: "Field Staff Add",
			component: () => import("@/pages/fieldStaff/Add.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/fieldStaff", // hyperlink
						text: "Field Staff", // crumb text
						disabled: false,
					},
					{
						to: "",
						text: "Add", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/fieldStaff/edit/:id",
			name: "Field Staff Edit",
			component: () => import("@/pages/fieldStaff/Add.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/fieldStaff", // hyperlink
						text: "Field Staff", // crumb text
						disabled: false,
					},
					{
						to: "",
						text: "Edit", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/ourTeam",
			name: "Our Team",
			component: () => import("@/pages/ourTeam/Index.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "", // hyperlink
						text: "Our Team", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/ourTeam/add",
			name: "Our Team Add",
			component: () => import("@/pages/ourTeam/Add.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/ourTeam", // hyperlink
						text: "Our Team", // crumb text
						disabled: false,
					},
					{
						to: "",
						text: "Add", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/ourTeam/edit/:id",
			name: "Team Member Edit",
			component: () => import("@/pages/ourTeam/Add.vue"),
			meta: {
				middleware: auth,
				layout: "main",
				breadCrumbs: [
					{
						to: "/", // hyperlink
						text: "Dashboard", // crumb text
						disabled: false,
					},
					{
						to: "/ourTeam", // hyperlink
						text: "Our Team", // crumb text
						disabled: false,
					},
					{
						to: "",
						text: "Edit", // crumb text
						disabled: true,
					},
				],
			},
		},
		{
			path: "/login",
			name: "login",
			component: () =>
				import(/* webpackChunkName: "login" */ "@/pages/auth/Index.vue"),
			meta: { layout: "none" },
		},
		{
			path: "/auth/:provider/callback",
			component: {
				template: '<div class="auth-component"></div>',
			},
		},
		{
			path: "/401",
			name: "401",
			component: () =>
				import(/* webpackChunkName: "about" */ "./pages/others/401.vue"),
		},
		{
			path: "/404",
			name: "404",
			component: () =>
				import(/* webpackChunkName: "about" */ "./pages/others/404.vue"),
		},
		{ path: "*", redirect: "/404" },
	],
});

// Creates a `nextMiddleware()` function which not only
// runs the default `next()` callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
	const subsequentMiddleware = middleware[index];
	// If no subsequent Middleware exists,
	// the default `next()` callback is returned.
	if (!subsequentMiddleware) return context.next;

	return (...parameters) => {
		// Run the default Vue Router `next()` callback first.
		context.next(...parameters);
		// Then run the subsequent Middleware with a new
		// `nextMiddleware()` callback.
		const nextMiddleware = nextFactory(context, middleware, index + 1);
		subsequentMiddleware({
			...context,
			next: nextMiddleware,
		});
	};
}

router.beforeEach((to, from, next) => {
	if (to.meta.middleware) {
		const middleware = Array.isArray(to.meta.middleware)
			? to.meta.middleware
			: [to.meta.middleware];
		const context = {
			from,
			next,
			router,
			to,
		};
		const nextMiddleware = nextFactory(context, middleware, 1);

		return middleware[0]({
			...context,
			next: nextMiddleware,
		});
	}

	return next();
});
export default router;
